module.exports = __webpack_public_path__ + "img/114012.91472eb2.png";